<template>
  <DataListStateful
    title="Тарифы"
    resource="tariffs"
    store="tariffs"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", dataPath: "Id", sortable: false },
        {
          title: "Направление",
          name: "direction",
          dataPath: "Direction.Title",
          sortable: true,
        },
        {
          title: "Категория товара",
          name: "productCategory",
          dataPath: "ProductCategory.Title",
          sortable: true,
        },
        {
          title: "Описание категории товара",
          name: "productCategoryDescription",
          dataPath: "ProductCategoryDescription",
          sortable: true,
        },
        {
          title: "Тип",
          name: "goodsType",
          dataPath: "GoodsType.Title",
          sortable: true,
        },
        {
          title: "Стандартный объемный вес ",
          name: "standardVolumetricWeight",
          dataPath: "StandardVolumetricWeight",
          sortable: true,
        },
        {
          title: "Тариф",
          name: "tariffValue",
          dataPath: "TariffValue",
          sortable: true,
        },
        {
          title: "Валюта",
          name: "currency",
          dataPath: "Currency.Title",
          sortable: true,
        },
      ],
      filter: {
        direction: {
          title: "Направление",
          type: "reference",
          resource: "countries",
        },
        productCategory: {
          title: "Категория товара",
          type: "reference",
          resource: "product-categories",
        },
        goodsType: {
          title: "Тип",
          type: "reference",
          resource: "goods-types",
        },
        currency: {
          title: "Валюта",
          type: "reference",
          resource: "currencies",
        },
      },
    };
  },
};
</script>